const summaryCategoryState = (state = {}, action) => {
    switch (action.type) {
        case 'UPDATE_SUMMARY_STATE':
            return {
                ...state,
                summaryState: action.payload
            };
        default:
            return state;
    }
};

export default summaryCategoryState;
